// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:52:46

export default {
  "id": "demolition-derby-derby",
  "slug": "demolition-derby-derby",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1b15b4311d284f5998cedc9d06913988-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1b15b4311d284f5998cedc9d06913988/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Demolition Derby Derby",
      "description": "Welcome to Demolition Derby the mobile sensation where you control the chaos! Strategically tap to toss dynamite and swipe to send rocks crashing down. Decimate buildings and statues with precision in this hyper-casual game.",
      "instructions": "The navigation in this game is very simple.\nUse your mouse or tap the screen to navigate in this game.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "destroy",
        "physics",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "拆毁大赛大赛",
      "description": "欢迎来到《爆破大赛》这款移动端热门游戏！在这里，您将掌控混乱！策略性地点击投掷炸药，滑动发送岩石坠落。在这款快节奏休闲游戏中，精准摧毁建筑和雕像。",
      "instructions": "这款游戏中的导航非常简单。\n使用鼠标或轻触屏幕来在游戏中导航。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "摧毁",
        "物理",
        "技能"
      ]
    },
    "zh-TW": {
      "title": "破壞賽車賽",
      "description": "歡迎來到毀滅賽車，這款手機熱門遊戲，讓您掌控混亂！策略性地點擊投擲炸藥，掃描發送石塊落下。以精準度毀壞建築和雕像，這是一款極端簡單的遊戲。",
      "instructions": "這款遊戲的導航非常簡單。\n使用滑鼠或點擊螢幕即可在遊戲中進行導航。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "破壞",
        "物理",
        "技能"
      ]
    },
    "zh-HK": {
      "title": "破壞賽車大賽",
      "description": "歡迎來到毀壞賽車，這是一款手機熱門遊戲，讓你掌控混亂！策略性地點擊投擲炸彈，掃描發射石塊。在這款超簡單遊戲中，精準毀壞建築和雕像。",
      "instructions": "遊戲中的導航非常簡單。\n使用滑鼠或觸控畫面以進行遊戲導航。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "破壞",
        "物理",
        "技能"
      ]
    },
    "ja": {
      "title": "デモリション・ダービー・ダービー",
      "description": "デモクラッシュダービーへようこそ！モバイルのスensation！あなたが混沌をコントロールする！戦略的にタップしてダイナマイトを投げ、スワイプして岩を落下させる。このハイパーカジュアルゲームで建物や像を精密に破壊せよ。",
      "instructions": "このゲームのナビゲーションは非常に簡単です。\nマウスを使用したり、スクリーンをタップすることでこのゲームのナビゲーションを行ってください。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "破壊",
        "物理",
        "スキル"
      ]
    },
    "ko": {
      "title": "톰버링 드러비 드러비",
      "description": "Demolition Derby로 환영합니다! 혼란을 통제하는 모바일 히트작에서! 전략적으로 탭하여 다이나마이트를 던지고 스와이프하여 돌이 떨어지도록 만듭니다. 이 하이퍼 캐주얼 게임에서 건물과 조각상을 정밀하게 파괴하세요.",
      "instructions": "이 게임의 네비게이션은 매우 간단합니다.\n마우스를 사용하거나 화면을 탭하여 이 게임에서 네비게이션하세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "파괴",
        "물리학",
        "기술"
      ]
    },
    "fr": {
      "title": "Dérbi de Démolition",
      "description": "Bienvenue à Demolition Derby, la sensation mobile où vous contrôlez le chaos ! Tappez stratégiquement pour lancer de la dynamite et faites glisser pour faire tomber des rochers. Détruissez des bâtiments et des statues avec précision dans ce jeu hyper-casual.",
      "instructions": "La navigation dans ce jeu est très simple.\nUtilisez votre souris ou appuyez sur l'écran pour naviguer dans ce jeu.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "détruire",
        "physique",
        "compétence"
      ]
    }
  }
};
